"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var CtaButton_1 = require("../common/Btn/CtaButton");
var HealthNeedsModule = function () {
    return ((0, preact_1.h)("div", { className: "health-needs-module" },
        (0, preact_1.h)("p", { className: "health-needs-module__header" }, "Shop by Health Need"),
        (0, preact_1.h)("p", { className: "health-needs-module__subheader" },
            "OBGYN-formulated products designed ",
            (0, preact_1.h)("br", { className: "hide-on-desktop" }),
            "to support ",
            (0, preact_1.h)("br", { className: "hide-on-mobile" }),
            "you from your first period to ",
            (0, preact_1.h)("br", { className: "hide-on-desktop" }),
            "well beyond your last."),
        (0, preact_1.h)("div", { className: "health-needs-module__needs-container" },
            (0, preact_1.h)("a", { href: "/collections/uro", className: "health-needs-module__needs", style: {
                    backgroundImage: 'url(https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-shop-options-uro-desktop.jpg?v=1726085290)',
                } },
                (0, preact_1.h)("p", { className: "health-needs-module__needs-text" },
                    "Vaginal &",
                    (0, preact_1.h)("br", null),
                    "Urinary Health \u2192")),
            (0, preact_1.h)("a", { href: "/collections/flo", className: "health-needs-module__needs", style: {
                    backgroundImage: 'url(https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-shop-options-flo-desktop.jpg?v=1726085289)',
                } },
                (0, preact_1.h)("p", { className: "health-needs-module__needs-text" },
                    "Period &",
                    (0, preact_1.h)("br", null),
                    "Hormone Health \u2192")),
            (0, preact_1.h)("a", { href: "/products/preggo-conception-sperm-health-support-capsules", className: "health-needs-module__needs", style: {
                    backgroundImage: 'url(https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-shop-options-preggo-desktop.jpg?v=1726085289)',
                } },
                (0, preact_1.h)("p", { className: "health-needs-module__needs-text" },
                    "Conception",
                    (0, preact_1.h)("br", null),
                    "Support \u2192")),
            (0, preact_1.h)("a", { href: "/collections/meno", className: "health-needs-module__needs", style: {
                    backgroundImage: 'url(https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-shop-options-meno-desktop.jpg?v=1726085289)',
                } },
                (0, preact_1.h)("p", { className: "health-needs-module__needs-text" },
                    "Menopause",
                    (0, preact_1.h)("br", null),
                    "Support \u2192"))),
        (0, preact_1.h)("div", { className: "health-needs-module__cta" },
            (0, preact_1.h)(CtaButton_1.default, { backgroundColor: {
                    to: 'Left',
                    startColor: 'gogo-orange',
                    endColor: 'gogo-pale-orange',
                }, hoverColor: "gogo-orange", text: "SHOP ALL", scrollTo: "/collections/shop-all" }))));
};
exports.default = HealthNeedsModule;
